export const CANVAS_BASE_SIZE = 40000;

export const CANVAS_CENTER = CANVAS_BASE_SIZE / 2;
